import { CentralSystemStatus } from '@energy-stacks/broker/feature-system-preferences-data';
import { ChargingStationDto } from '../chargingStationDto';
import { ChargingStationModel } from '../chargingStationModel';
import { appendZToDateString } from '@energy-stacks/shared';
import { connectorShadowNormalizer } from './connectorShadowNormalizer';
import { BrokerChargingStationDto } from './chargingStationDetailsNormalizer';
import { getCSStatus } from '../getCSStatus';

export const chargingStationsBrokerNormalizer = (
  chargingStation: BrokerChargingStationDto
): ChargingStationModel => {
  return {
    geolocation: chargingStation.coordinates ?? {
      latitude: '-',
      longitude: '-',
    },
    location: chargingStation.location ?? { uuid: 'N/A', name: 'N/A' },
    identityKey: chargingStation.identityKey ?? 'N/A',
    online:
      chargingStation.online === null
        ? 'provisioned'
        : chargingStation.online
        ? 'online'
        : 'offline',
    model: chargingStation.chargingStationModel ?? 'N/A',
    name: chargingStation.chargingStationName ?? 'N/A',
    csmsUuid: chargingStation.csmsUuid ?? 'N/A',
    centralSystemStatus: chargingStation.csmsConnected
      ? CentralSystemStatus.Online
      : CentralSystemStatus.Offline,
    firmware: chargingStation.shadow?.firmwareVersion ?? 'N/A',
    serialNumber: chargingStation.serialNumber
      ? chargingStation.serialNumber
      : 'N/A',
    dateCreated: appendZToDateString(chargingStation.dateCreated),
    ocppProtocol: chargingStation.shadow?.ocppProtocol ?? 'N/A',
    connectors:
      chargingStation.shadow?.connectors?.map((connector) =>
        connectorShadowNormalizer(connector)
      ) ?? [],
    csStatus:
      chargingStation.online === null
        ? 'provisioned'
        : getCSStatus(chargingStation.shadow?.chargingStationStatus),
    shadowSerialNumber: chargingStation.shadow?.chargingStationSerialNumber
      ? chargingStation.shadow?.chargingStationSerialNumber
      : 'N/A',
  };
};

export const chargingStationsNormalizer = (
  chargingStations: Partial<ChargingStationDto>[]
): ChargingStationModel[] => {
  return chargingStations.map((chargingStation) => ({
    firmware: chargingStation.shadow?.firmwareVersion ?? 'N/A',
    // There is no geolocation field in BE
    geolocation: chargingStation.coordinates ?? {
      latitude: '-',
      longitude: '-',
    },
    location: chargingStation.location ?? { uuid: 'N/A', name: 'N/A' },
    identityKey: chargingStation.identityKey ?? 'N/A',
    model: chargingStation.chargingStationModel ?? 'N/A',
    name: chargingStation.chargingStationName ?? 'N/A',
    serialNumber: chargingStation.serialNumber
      ? chargingStation.serialNumber
      : 'N/A',
    online:
      chargingStation.online === null
        ? 'provisioned'
        : chargingStation.online
        ? 'online'
        : 'offline',
    csmsUuid: chargingStation.csmsUuid ?? 'N/A',
    centralSystemStatus: chargingStation.csmsConnected
      ? CentralSystemStatus.Online
      : CentralSystemStatus.Offline,
    dateCreated: appendZToDateString(chargingStation.dateCreated),
    ocppProtocol: chargingStation.shadow?.ocppProtocol ?? 'N/A',
    connectors:
      chargingStation.shadow?.connectors?.map((connector) =>
        connectorShadowNormalizer(connector)
      ) ?? [],
    csStatus:
      chargingStation.online === null
        ? 'provisioned'
        : getCSStatus(chargingStation.shadow?.chargingStationStatus),
    shadowSerialNumber: chargingStation.shadow?.chargingStationSerialNumber
      ? chargingStation.shadow?.chargingStationSerialNumber
      : 'N/A',
  }));
};
